import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { ScanIqCustomer } from '../interfaces/ScanIqCustomer';

class ScanIqStore {
  customer: ScanIqCustomer | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.customer = null;
  }

  setCustomer(customer: ScanIqCustomer) {
    this.customer = customer;
  }
}

const scanIqStore = new ScanIqStore();
resetAllStore.addResetMethod(scanIqStore.setDefaultValues);

export { scanIqStore, ScanIqStore };
